import * as React from 'react';

import {
  CO_OCCURRENCE_MISCONCEPTION,
  MISCONCEPTIONS_BAR_CHART,
  OVERALL_RESPONSE_BAR_CHART,
  OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART,
  RUBRIC_SCORES_VS_END_OF_YEAR_SCORES,
  STRATEGY_USE_FREQUENCY,
  SUBMISSIONS_VOLUME_BAR_CHART
} from 'entities/Charts/constants';

import Box from 'components/Box';
import Tab from 'components/Tab';
import Tabs from 'components/Tabs';

interface BarChartTabsProps {
  value: string;
  setValue: (value: string) => void;
}

const BarChartTabs = ({ value, setValue }: BarChartTabsProps) => {
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Overall Response" value={OVERALL_RESPONSE_BAR_CHART} />
        <Tab label="Misconceptions" value={MISCONCEPTIONS_BAR_CHART} />
        <Tab label="Submissions Volume" value={SUBMISSIONS_VOLUME_BAR_CHART} />
        <Tab
          label="Overall Response Distribution"
          value={OVERALL_RESPONSE_DISTRIBUTION_BAR_CHART}
        />
        <Tab
          label="Co-Occurrence Misconception"
          value={CO_OCCURRENCE_MISCONCEPTION}
        />
        <Tab
          label="Rubric Scores vs End of Year Scores"
          value={RUBRIC_SCORES_VS_END_OF_YEAR_SCORES}
        />
        <Tab label="Strategy Use Frequency" value={STRATEGY_USE_FREQUENCY} />
      </Tabs>
    </Box>
  );
};

export default BarChartTabs;
